import Shevy from "shevyjs";

import Typography from "typography";

// import { sansSerif } from "./fonts";

// export default new Typography({
//   baseFontSize: "18px",
//   baseLineHeight: 1.333,
//   headerFontFamily: sansSerif.split("; "),
//   bodyFontFamily: sansSerif.split("; "),
// });

export const baseFontSize = 18;

export const shevy = new Shevy({
  baseFontSize: `${baseFontSize}px`,
  baseLineHeight: 1.4,
  baseFontScale: [2.5, 2, 1.5, 1.25, 1, 1],
  addMarginBottom: true,
  proximity: false,
  proximityFactor: 0.85,
});



// WEBPACK FOOTER //
// ./src/styles/typography.js